import { Avatar, Typography } from 'antd';
import type { EmployeeListItem } from '@/entities/employee/model/employeeApiSchema';
import s from './EmployeeRow.module.scss';

const { Text } = Typography;

function initials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return fullName.slice(0, 2).toUpperCase();
}

const AVATAR_COLORS = ['#2563EB', '#7C3AED', '#0891B2', '#BE185D', '#059669', '#DC2626'] as const;

function colorForKey(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function EmployeeRow({ emp, onClick }: { emp: EmployeeListItem; onClick: () => void }) {
  return (
    <div
      className={s['root__emp-row']}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick();
      }}
    >
      <Avatar
        size={40}
        className={s.root__avatar}
        style={{ backgroundColor: colorForKey(emp.id || emp.full_name), color: '#fff' }}
      >
        {initials(emp.full_name)}
      </Avatar>
      <div className={s['root__emp-main']}>
        <Text strong className={s['root__emp-name']}>
          {emp.full_name}
        </Text>
        <div className={s['root__emp-meta']}>
          {emp.position.name} · {emp.org_unit.name}
        </div>
      </div>
    </div>
  );
}
